import { APP_TYPES } from '../../apiLogic/constants';
import i18next from 'i18next';
import AppData from '../../models/appData';
import { ALLOWED_LOCALES_FOR_PAYMENTS } from '../../apiLogic/constants';

async function AuthUrl(history) {
    const appType = window.$appName;
    AppData.setData(appType);
    let localeOrCountry = history.location.pathname.split('/')[1].toLowerCase();
    
    const allowedLocales = ALLOWED_LOCALES_FOR_PAYMENTS[appType];
    if ((appType === APP_TYPES.SELF_PAYMENT || appType === APP_TYPES.INVOICE_POST_PAYMENT || appType === APP_TYPES.SIMPLY_GOLDSTAR) && !allowedLocales.includes(localeOrCountry)) {
        let path = '/notfound';
        if (process.env.feature) {
            path = `${path`?feature=${process.env.feature.split['/'][1]}`}`;
        }
        return history.push(path);
    }
    //setting i18 lang
    if (!AppData.isSiteActive(localeOrCountry)) {
        AppData.setLangAndLocaleCode('ie');
        await i18next.changeLanguage('en');
        history.push('/notfound');
    } else {
        AppData.setLangAndLocaleCode(localeOrCountry);
        const i18nextLang = AppData.getI18nextLang();
        await i18next.changeLanguage(i18nextLang);
    }
}

export default AuthUrl;
